import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteItemPhoto, useItemPhotos } from '@/hooks/item';
import { ItemPhotoDeleteModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';

const View: React.FC<{ modal: ItemPhotoDeleteModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { itemId, photo, onClose } = modal;

  const photosR = useItemPhotos(itemId, false);
  const submitR = useDeleteItemPhoto(itemId, photo);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      photosR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.item_photo_delete.title_alert')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.item_photo_delete.title_alert')}
        onClose={onClose}
      />
    );
  }

  const body = submitR.kind === 'Loading' ? <LoadingBodyModal height={40} /> : <></>;

  return (
    <StandardModal
      title={t('modal.item_photo_delete.title')}
      onClose={onClose}
      onSubmit={submitR.mutate}
      closeLabel={t('common.no').toUpperCase()}
      submitLabel={t('common.yes').toUpperCase()}
      submittable={submitR.kind !== 'Loading'}
      body={body}
      containerStyle={{ width: 500 }}
      modalName="item_photo_delete"
    />
  );
};

export default View;
